export default __webpack_public_path__ + "static/media/student.afae0ac6.png";